import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { CardContent } from '@material-ui/core'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Project } from 'Models/project'
import NewProjectSlideOut from 'pages/ProjectsPage/components/NewProjectSlideOut'
import React from 'react'
import { ProjectDetails } from './ProjectDetails'
import { ProjectOverviewMenu } from './ProjectOverviewMenu'

const useStyles = makeStyles((theme: Theme) => ({
    card: {
        boxShadow: 'none',
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: '#242424',
        borderRadius: 0,
    },
    content: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        color: '#fff',
        padding: 0,
        fontSize: pxToRem(13),
        '&.MuiCardContent-root': {
            paddingBottom: theme.spacing(1.5),
        },
    },
    header: {
        color: theme.palette.common.white,
        fontStyle: 'normal',
        fontWeight: 'normal',
        paddingBottom: 0,
        paddingLeft: theme.spacing(3),
        paddingTop: theme.spacing(1.875),
        '& span': {
            fontSize: pxToRem(24),
        },
    },
}))

interface ProjectOverviewDetailsProps {
    projectData: Partial<Project> | undefined
    triggerProjectReload: VoidFunction
    variant?: 'readOnly' | 'full'
}
export const ProjectOverviewDetails: React.FC<ProjectOverviewDetailsProps> = ({
    projectData,
    triggerProjectReload,
    variant,
}) => {
    const classes = useStyles()
    const [slideOutOpen, toggleSlideOut] = React.useState<boolean>(false)

    const handleCloseSlideOut = () => {
        toggleSlideOut(false)
    }

    const handleOpenSlideOut = () => {
        toggleSlideOut(true)
    }

    const items = [
        {
            text: 'Edit',
            onClick: handleOpenSlideOut,
            testId: 'liEditProjectDetails',
        },
    ]

    return (
        <>
            <Card
                className={classes.card}
                data-testid="dvProjectOverviewDetails"
            >
                <CardHeader
                    className={classes.header}
                    action={
                        variant === 'full' && (
                            <ProjectOverviewMenu items={items} />
                        )
                    }
                    titleTypographyProps={{
                        variant: 'h4',
                        gutterBottom: true,
                    }}
                    title="Details"
                />
                <CardContent className={classes.content}>
                    <ProjectDetails projectData={projectData} />
                </CardContent>
            </Card>

            <NewProjectSlideOut
                open={slideOutOpen}
                onClose={handleCloseSlideOut}
                triggerProjectListReload={triggerProjectReload}
                projectData={projectData}
            />
        </>
    )
}
export default ProjectOverviewDetails
